import { types, getSnapshot, applySnapshot } from 'mobx-state-tree';
import generateUUID from 'uuid/v1';
import { castEventToValue } from 'js/services/FormTools';
import { blueColor } from 'js/config/style';

export default types
  .model('DebitAccount', {
    uuid: types.optional(types.string, generateUUID),
    id: 0,
    number: '',
    last_4_digits: '',
    type: '',
  })
  .views(self => ({
    get isNew() {
      return !self.id;
    },
    get isFilledIn() {
      return !!((self.last_4_digits) || self.id);
    },
  }))
  .actions(self => ({
    setId(id) {
      self.id = id;
      return self;
    },
    setNumber(number) {
      self.number = castEventToValue(number);
      return self;
    },
    setType(type) {
      self.type = castEventToValue(type);
      return self;
    },
    setDebitAccount(snapshot) {
      applySnapshot(self, snapshot ? { ...getSnapshot(self), ...snapshot } : {});
      return self;
    },
  }));
